import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EmailPreviewComponent } from '../email-preview/email-preview.component';

export interface DadosPreviewEmail {
  remetente?: string;
  assunto?: string;
  html: string;
}

@Component({
  selector: 'app-modal-preview-email',
  standalone: true,
  imports: [MatIconModule, EmailPreviewComponent],
  templateUrl: './modal-preview-email.component.html',
  styleUrl: './modal-preview-email.component.css'
})
export class ModalPreviewEmailComponent {
  private readonly dialogRef = inject(MatDialogRef<ModalPreviewEmailComponent>);
  readonly dados = inject<DadosPreviewEmail>(MAT_DIALOG_DATA);

  fechar(): void {
    this.dialogRef.close();
  }
}
